import { useTranslation } from 'react-i18next';

interface ReviewCardProps {
  id: number;
  avatar: string;
  name: string;
  rating: number;
  review: string;
  isNew?: boolean;
}

export default function ReviewCard({ avatar, name, rating, review, isNew = false }: ReviewCardProps) {
  const { t } = useTranslation(['timer', 'common']);
  
  return (
    <div className={`flex-shrink-0 p-4 md:p-6 rounded-lg w-80 ${isNew ? 'bg-blue-50 border border-blue-200' : 'bg-gray-50'}`}>
      {isNew && (
        <div className="flex items-center mb-3">
          <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded-full">
            {t('reviews.newReview')}
          </span>
        </div>
      )}
      <div className="flex items-center mb-3 md:mb-4">
        <img
          src={avatar}
          alt={`${name} avatar`}
          className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover mr-3"
          onError={(e) => {
            // 如果头像加载失败，使用默认头像
            (e.target as HTMLImageElement).src = "/images/avatars/default.png";
          }}
        />
        <div className="flex-1">
          <div className="flex text-yellow-400 mb-1">
            {[...Array(5)].map((_, i) => (
              <i key={i} className={`${i < rating ? 'ri-star-fill' : 'ri-star-line'} text-sm`}></i>
            ))}
          </div>
          <span className="text-xs md:text-sm text-gray-600 font-medium">{name}</span>
        </div>
      </div>
      <p className="text-gray-700 text-sm md:text-base">{review}</p>
    </div>
  );
}